import { createAsyncThunk } from '@reduxjs/toolkit';

import type { CategoryBreakdownDto } from '../types/ReportSavingsSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSavingsByCategoryParams {
    dateFrom: string;
    dateTo: string;
    propertyIds?: string[];
    categoryIds?: string[];
}

export const fetchSavingsByCategory = createAsyncThunk<
    CategoryBreakdownDto[],
    FetchSavingsByCategoryParams,
    ThunkConfig<string>
>(
    'reportSavingsSummary/fetchSavingsByCategory',
    async ({ dateFrom, dateTo, propertyIds, categoryIds }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;
        try {
            const params: Record<string, string> = {
                date_from: dateFrom,
                date_to: dateTo,
            };
            if (propertyIds?.length) {
                params.property_ids = propertyIds.join(',');
            }
            if (categoryIds?.length) {
                params.category_ids = categoryIds.join(',');
            }
            const response = await extra.api.get<{
                items: CategoryBreakdownDto[];
            }>('/v1/reports/savings-insights/by-category', { params });
            return response.data.items ?? [];
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
